import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "campaign-delight/settings",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const journifySetting = require("./CampaignDelightSettings").default;
          cb(null, journifySetting);
        },
        "CampaignDelightSettings"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/CampaignDelightSettings/index.js